module.exports = __webpack_public_path__ + "static/media/dave-ramsey.eb338098.svg";